export default "__VITE_ASSET__DPbXWUbP__"